import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  // Menu,
  // X,
  MenuItem,
  Typography,
  TextField,
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  Avatar,
} from "@mui/material";
import { Person } from "@mui/icons-material";
import "./Navbar.css";
import apiClient from "./apiClient";
import LogoBrand from "../assets/Logo Musique Hitam.png";
import SearchButton from "../assets/Search_Magnifying_Glass.svg";
import CartButton from "../assets/Shopping_Cart_02.svg";
import UserButton from "../assets/User_01.svg";
import FlagIndo from "../assets/Flag_indo.svg";
import { Menu, X } from "lucide-react";
import { useCart } from "../components/CartContext";

const Navbar = () => {
  const userMenuButtonRef = useRef(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [cartCount, setCartCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [megaMenuVisible, setMegaMenuVisible] = useState(false);
  // const [anchorElLanguage, setAnchorElLanguage] = useState(null);
  const [showNavbar, setShowNavbar] = useState(true);
  const navigate = useNavigate();
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [userImage, setUserImage] = useState(null); // State untuk gambar pengguna
  const [userMegaMenuVisible, setUserMegaMenuVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [produk, setProduk] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedKategori, setSelectedKategori] = useState(null);
  const [profile, setProfile] = useState({
    nama: "",
    email: "",
    telepon: "",
    alamat: "",
    imageUrl: "",
  });
  const { clearCart } = useCart();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiClient.get("/kategori");
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const { kategoriId: urlKategoriId } = useParams();
  const kategoriId = urlKategoriId || localStorage.getItem("kategoriId");

  const { kategoriNama: urlKategoriNama } = useParams();
  const kategoriNama = urlKategoriNama || localStorage.getItem("kategoriNama");

  const handleCategoryClick = async (kategoriId) => {
    setSelectedKategori(kategoriId);
    setLoading(true);
    setError("");
    localStorage.setItem("kategoriId", kategoriId);

    // navigate(`/produk-kategori/${kategoriId}`);

    try {
      const produkResponse = await apiClient.get(
        `/produk/kategori/${kategoriId}`
      );
      setProduk(produkResponse.data);
    } catch (err) {
      setError("Failed to get Product");
    } finally {
      setLoading(false);
    }
  };

  // const handleCategoryClick = async (kategoriNama) => {
  //   setSelectedKategori(kategoriNama);
  //   setLoading(true);
  //   setError("");

  //   localStorage.setItem("kategoriNama", kategoriNama);

  //   navigate(`/kategori-produk/${kategoriNama}`);

  //   try {
  //     const produkResponse = await apiClient.get(
  //       `/produk/kategori/getnama/${kategoriNama}`
  //     );
  //     setProduk(produkResponse.data);
  //   } catch (err) {
  //     setError("Failed to get Product");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleCategoryClickMobile = async (kategoriId) => {
    setSelectedKategori(kategoriId);
    setLoading(true);
    setError("");
    localStorage.setItem("kategoriId", kategoriId);
    navigate(`/produk-kategori/${kategoriId}`);

    try {
      const produkResponse = await apiClient.get(
        `/produk/kategori/${kategoriId}`
      );
      setProduk(produkResponse.data);
    } catch (err) {
      setError("Failed to get Product");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!kategoriId) {
      setError("Kategori tidak ditemukan");
      setLoading(false);
      return;
    }

    const fetchProduk = async () => {
      try {
        setLoading(true);
        const produkResponse = await apiClient.get(
          `/produk/kategori/${kategoriId}`
        );
        setProduk(produkResponse.data);
      } catch (err) {
        setError("Product Not Found");
      } finally {
        setLoading(false);
      }
    };

    fetchProduk();
  }, [kategoriId]);

  const handleProductsClick = async () => {
    setIsOpen(!isOpen); // Keep the dropdown toggle

    if (!categories.length) {
      // Fetch categories only if not loaded
      try {
        const response = await apiClient.get("/kategori");
        setCategories(response.data);

        if (response.data.length > 0) {
          const firstCategory = response.data[0];
          setSelectedKategori(firstCategory.id);
          localStorage.setItem("kategoriId", firstCategory.id);
          // navigate(`/produk-kategori/${firstCategory.id}`);
        }
      } catch (error) {
        console.error("Error fetching first category:", error);
      }
    } else {
      // If categories are already loaded, ensure it selects the first category
      const firstCategory = categories[0];
      if (firstCategory) {
        setSelectedKategori(firstCategory.id);
        localStorage.setItem("kategoriId", firstCategory.id);
        // navigate(`/produk-kategori/${firstCategory.id}`);
      }
    }
  };
  // Handle scroll to show/hide navbar
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowNavbar(false); // Scroll ke bawah, sembunyikan navbar
      } else {
        setShowNavbar(true); // Scroll ke atas, tampilkan navbar
      }
      lastScrollY = window.scrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fetch user profile data
  useEffect(() => {
    const fetchUserProfileAndCart = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const profileRes = await apiClient.get("/user/profile", {
            headers: { Authorization: `Bearer ${token}` },
          });

          setProfile(profileRes.data);
          setUserName(profileRes.data.nama || "Pengguna");
          setIsLoggedIn(true);

          // ✅ Fetch cart from server
          const cartRes = await apiClient.get("/cart", {
            headers: { Authorization: `Bearer ${token}` },
          });

          const serverCart = cartRes.data.cartItems || [];

          // Convert jumlah (which is string) to number safely
          const totalItems = serverCart.reduce(
            (total, item) => total + parseInt(item.jumlah, 10),
            0
          );

          setCartCount(totalItems);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchUserProfileAndCart();

    const updateCartCount = () => {
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      setCartCount(
        cart.reduce((total, item) => total + Number(item.jumlah), 0)
      );
    };

    window.addEventListener("cart-updated", updateCartCount);

    return () => {
      window.removeEventListener("cart-updated", updateCartCount);
    };
  }, []);
  // Add [] to only run once on mount

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("cart");
    setIsLoggedIn(false);
    clearCart();
    setIsOTPVerified(false); // Reset OTP verification state on logout
    navigate("/login");
  };

  const handleOTPVerification = () => {
    setIsOTPVerified(true); // Set to true after successful verification
  };

  // Handle cart click
  const handleCartClick = () => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate("/cart");
    }
  };

  // Handle user menu click
  const handleUserMenuClick = () => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      setUserMegaMenuVisible(!userMegaMenuVisible);
      // setUserMegaMenuVisible((prev) => !prev);
    }
  };

  // Close the menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userMenuButtonRef.current &&
        !userMenuButtonRef.current.contains(event.target) &&
        !event.target.closest(".mega-menu-user")
      ) {
        setUserMegaMenuVisible(false); // Close the menu if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close the mega menu when clicking a menu item
  const handleMenuItemClick = (path) => {
    setUserMegaMenuVisible(false); // Close the menu after item click
    if (path) {
      navigate(path); // Navigate to the specific path
    }
  };

  const closeUserMenu = () => {
    setDropdownOpen(false);
  };

  const handleSearchIconClick = () => setMegaMenuVisible(!megaMenuVisible);

  const handleSearchChange = async (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.length > 2) {
      try {
        const response = await apiClient.get(`/produk/all?query=${query}`);
        // const response = await apiClient.get(`/produk/getnama?query=${query}`);
        const filteredResults = response.data.filter((item) => {
          const productName = item.nama_produk?.toLowerCase() || "";
          const brandName = item.brand?.nama_brand?.toLowerCase() || "";
          const lowerQuery = query.toLowerCase();

          return (
            productName.includes(lowerQuery) || brandName.includes(lowerQuery)
          );
        });

        setSearchResults(filteredResults);
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    } else {
      setSearchResults([]); // Clear search results if query length is less than 3
    }
  };

  const handleSearchItemClick = (item) => {
    // navigate(`/produk/all/${item.id}`);
    navigate(`/all-produk/${item.nama_produk}`);
    setMegaMenuVisible(false);
  };

  // Handle language menu
  // const handleLanguageMenuOpen = (event) => {
  //   setAnchorElLanguage(event.currentTarget);
  // };

  // const handleLanguageMenuClose = (language) => {
  //   setAnchorElLanguage(null);
  //   if (language) {
  //     console.log(`Language changed to: ${language}`);
  //   }
  // };

  const toggleUserMegaMenu = () => {
    setUserMegaMenuVisible(!userMegaMenuVisible);
  };

  const handleCategoryLink = (categoryId) => {
    setSelectedKategori(categoryId); // Update selected category
    localStorage.setItem("kategoriId", categoryId); // Save category ID
    setIsOpen(false); // Close dropdown
    navigate(`/produk-kategori/${categoryId}`);
  };

  const isNewProduct = (createdAt) => {
    if (!createdAt) return false;
    const productDate = new Date(createdAt);
    const currentDate = new Date();

    return (
      productDate.getMonth() === currentDate.getMonth() &&
      productDate.getFullYear() === currentDate.getFullYear()
    );
  };

  const fetchNewProducts = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/produk/all");
      const allProducts = response.data || [];

      // Filter only new products
      const newProducts = allProducts.filter((item) =>
        isNewProduct(item.createdAt)
      );

      setProduk(newProducts); // Update state with only new products
    } catch (error) {
      setError("Failed to fetch new products.");
      console.error("Error fetching new products:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchNewProducts();
  }, []);

  useEffect(() => {
    const fetchCartCount = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const cartRes = await apiClient.get("/cart", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const serverCart = cartRes.data.cartItems || [];
        const totalItems = serverCart.reduce(
          (total, item) => total + parseInt(item.jumlah, 10),
          0
        );
        setCartCount(totalItems);
      } catch (error) {
        console.error("Failed to fetch cart:", error);
      }
    };

    // Fetch once on load
    fetchCartCount();

    // Fetch whenever cart is updated
    const handleUpdate = () => fetchCartCount();

    window.addEventListener("cart-updated", handleUpdate);

    return () => {
      window.removeEventListener("cart-updated", handleUpdate);
    };
  }, []);

  const [isNewProductsSelected, setIsNewProductsSelected] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);

  const [activeTab, setActiveTab] = useState("new-products");

  const [menuOpen, setMenuOpen] = useState(false);
  const buttonRef = useRef(null);

  const handleLanguageMenuOpen = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLanguageMenuClose = (lang) => {
    console.log("Selected Language:", lang);
    setMenuOpen(false);
  };

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [productDropdownOpen, setProductDropdownOpen] = useState(false);

  // return (
  //   <div
  //     className={`fixed top-0 left-0 w-full bg-white shadow-md transition-transform duration-300 z-[999]
  //       ${showNavbar ? "translate-y-0" : "-translate-y-full"}`}
  //     style={{ height: "108px" }}
  //   >
  //     <div className="max-w-6xl mx-auto flex items-center justify-between py-4">
  //       <Link to="/" className="flex items-center w-64">
  //         <img src={LogoBrand} alt="Logo" className="h-16" />
  //       </Link>

  //       <div className="flex items-center justify-center gap-10 text-lg relative w-full">
  //         <Link
  //           className="text-black font-semibold px-4 py-2 rounded-lg hover:bg-gray-200 transition  whitespace-nowrap"
  //           to="/"
  //         >
  //           Home
  //         </Link>

  //         <div className="relative">
  //           <button
  //             onClick={handleProductsClick}
  //             className="text-black font-semibold px-4 py-2 rounded-lg hover:bg-gray-200 transition"
  //           >
  //             Products
  //           </button>

  //           {isOpen && (
  //             <div className="fixed left-0 w-full bg-white border border-gray-300 shadow-lg z-50">
  //               <div className="px-10 py-4 grid grid-cols-3 gap-4">
  //                 {/* Left Column: Categories */}
  //                 <div className="col-span-1">
  //                   <ul className="flex flex-col gap-2">
  //                     <li
  //                       className={`text-black px-4 py-2 cursor-pointer transition ${
  //                         selectedTab === "New Products"
  //                           ? "bg-black text-white"
  //                           : "hover:bg-black hover:text-white"
  //                       }`}
  //                       onClick={() => {
  //                         setSelectedTab("New Products");
  //                         fetchNewProducts();
  //                       }}
  //                     >
  //                       New Products
  //                     </li>
  //                     <li
  //                       className="px-4 py-2 hover:bg-black hover:text-white cursor-pointer font-bold"
  //                       onClick={() => setIsOpen(false)}
  //                     >
  //                       <Link
  //                         to="/all-produk-new"
  //                         className="block w-full h-full"
  //                       >
  //                         View All
  //                       </Link>
  //                     </li>

  //                     {categories.map((category) => (
  //                       <li
  //                         key={category.id}
  //                         className={`text-black px-4 py-2 cursor-pointer ${
  //                           selectedKategori === category.id
  //                             ? "bg-black text-white"
  //                             : "hover:bg-black hover:text-white"
  //                         }`}
  //                         onClick={() => handleCategoryClick(category.id)}
  //                       >
  //                         {category.nama_kategori}
  //                       </li>
  //                     ))}
  //                   </ul>
  //                 </div>

  //                 <div className="col-span-2">
  //                   {kategoriId && (
  //                     <div className="flex justify-end">
  //                       <button
  //                         className="mb-4 px-4 py-2 bg-black text-white rounded hover:bg-blue-600"
  //                         onClick={() => {
  //                           setIsOpen(false);
  //                           navigate(`/produk-kategori/${kategoriId}`);
  //                         }}
  //                       >
  //                         View All
  //                       </button>
  //                     </div>
  //                   )}

  //                   {loading ? (
  //                     <p className="text-center">Loading...</p>
  //                   ) : error ? (
  //                     <p className="text-center text-red-500">{error}</p>
  //                   ) : produk.length > 0 ? (
  //                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
  //                       {produk.slice(0, 6).map((item) => (
  //                         <div key={item.id} className="relative p-2">
  //                           {isNewProduct(item.createdAt) && (
  //                             <span className="absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-1 rounded-md font-semibold">
  //                               NEW
  //                             </span>
  //                           )}
  //                           <img
  //                             src={item.image[0]}
  //                             alt={item.nama_produk}
  //                             className="w-full h-24 sm:h-28 md:h-32 object-contain rounded-lg"
  //                           />
  //                           <p className="text-center mt-2 text-sm sm:text-base md:text-lg text-black font-medium">
  //                             {item.nama_produk}
  //                           </p>
  //                         </div>
  //                       ))}
  //                     </div>
  //                   ) : (
  //                     <p className="text-center text-gray-600">
  //                       No new products available.
  //                     </p>
  //                   )}
  //                 </div>
  //               </div>
  //             </div>
  //           )}
  //         </div>

  //         <Link
  //           className="text-black font-semibold px-4 py-2 rounded-lg hover:bg-gray-200 transition  whitespace-nowrap"
  //           to="/all-brand"
  //         >
  //           Brand
  //         </Link>
  //         <Link
  //           className="text-black font-semibold px-4 py-2 rounded-lg hover:bg-gray-200 transition  whitespace-nowrap"
  //           to="/our-outlet"
  //         >
  //           Store
  //         </Link>
  //         <Link
  //           className="text-black font-semibold px-4 py-2 rounded-lg hover:bg-gray-200 transition whitespace-nowrap"
  //           to="/e-catalog"
  //         >
  //           E-Catalog
  //         </Link>
  //       </div>

  //       <div className="flex items-center gap-2 relative">
  //         {/* Search Button */}
  //         <IconButton
  //           onClick={handleSearchIconClick}
  //           className="focus:outline-none"
  //         >
  //           <img src={SearchButton} alt="Search Icon" className="h-7" />
  //         </IconButton>

  //         <IconButton
  //           onClick={handleCartClick}
  //           className="relative focus:outline-none w-10 h-10 flex items-center justify-center"
  //         >
  //           {cartCount > 0 && (
  //             <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5">
  //               {cartCount}
  //             </span>
  //           )}
  //           <img
  //             src={CartButton}
  //             alt="Cart Icon"
  //             className="block w-auto h-8"
  //           />
  //         </IconButton>

  //         <IconButton
  //           onClick={handleUserMenuClick}
  //           className="focus:outline-none"
  //         >
  //           {userImage ? (
  //             <img
  //               src={userImage}
  //               alt="User Image"
  //               className="h-8 w-8 rounded-full"
  //             />
  //           ) : (
  //             <img src={UserButton} alt="User Icon" className="h-8" />
  //           )}
  //         </IconButton>

  //         {isLoggedIn && userMegaMenuVisible && (
  //           <div className="fixed top-24 left-1/2 transform -translate-x-1/2 w-full max-w-3xl bg-white shadow-lg z-50 p-4 transition-all duration-300 ease-in-out scale-100 opacity-100">
  //             <div className="flex justify-between items-center p-4">
  //               {/* User Avatar */}
  //               <div className="flex flex-col items-center">
  //                 <img
  //                   src={userImage || ""}
  //                   alt="User Avatar"
  //                   className="h-40 w-40 rounded-full bg-gray-200"
  //                 />
  //               </div>

  //               <ul className="space-y-3 text-lg text-gray-700">
  //                 <li>
  //                   <button
  //                     onClick={() => navigate("/settings")}
  //                     className="hover:text-black transition"
  //                   >
  //                     Account
  //                   </button>
  //                 </li>
  //                 <li>
  //                   <button
  //                     onClick={() => navigate("/order-history")}
  //                     className="hover:text-black transition"
  //                   >
  //                     Order History
  //                   </button>
  //                 </li>
  //                 <li>
  //                   <button
  //                     onClick={handleLogout}
  //                     className="text-red-500 hover:text-red-700 transition"
  //                   >
  //                     Logout
  //                   </button>
  //                 </li>
  //               </ul>
  //             </div>
  //           </div>
  //         )}

  //         <IconButton
  //           onClick={handleLanguageMenuOpen}
  //           className="focus:outline-none"
  //         >
  //           <img
  //             src={FlagIndo}
  //             alt="Language Selector"
  //             className="h-7 w-10 object-cover"
  //           />
  //         </IconButton>
  //         <div className="relative inline-block">
  //           {menuOpen && (
  //             <div className="absolute top-full right-0 mt-2 bg-white shadow-lg rounded-md z-50">
  //               <button
  //                 onClick={() => handleLanguageMenuClose("en")}
  //                 className="text-black text-left block px-4 py-2 hover:bg-gray-200 w-full"
  //               >
  //                 English
  //               </button>
  //               <button
  //                 onClick={() => handleLanguageMenuClose("id")}
  //                 className="text-black text-left block px-4 py-2 hover:bg-gray-200 w-full"
  //               >
  //                 Bahasa Indonesia
  //               </button>
  //             </div>
  //           )}
  //         </div>
  //       </div>
  //     </div>

  //     {megaMenuVisible && (
  //       <div className="absolute top-[88px] left-0 right-0 z-10 p-4 bg-white shadow-lg rounded-md w-full mx-auto">
  //         <input
  //           type="text"
  //           placeholder="Search..."
  //           value={searchQuery}
  //           onChange={handleSearchChange}
  //           className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 text-black"
  //         />

  //         <ul className="mt-2 bg-white rounded-md shadow-md max-h-60 overflow-y-auto">
  //           {searchResults.length > 0 ? (
  //             searchResults.map((item) => (
  //               <li
  //                 key={item.id}
  //                 className="p-2 hover:bg-gray-100 cursor-pointer transition duration-200 text-black"
  //                 onClick={() => handleSearchItemClick(item)}
  //               >
  //                 {item.nama_produk}
  //               </li>
  //             ))
  //           ) : (
  //             <li className="p-2 text-black text-center">No results found</li>
  //           )}
  //         </ul>
  //       </div>
  //     )}
  //   </div>
  // );

  return (
    <>
    <div className="fixed top-0 left-0 w-full min-h-[50px] z-[50] bg-[#CCAB5C] flex items-center justify-center text-sm text-black px-2 py-1 text-center">
        <p className="flex flex-wrap justify-center items-center gap-x-1">
          Get <strong>3% off</strong> on your first order | Use code:{" "}
          <strong>HelloMusique</strong>
          {/* Get <strong>30% off</strong> on your first order | Use code:{" "}
          <strong>Sansui30</strong> */}
        </p>
      </div>

      {/* <div className="fixed top-0 left-0 w-full min-h-[50px] z-[50] bg-[#FF9A9A] flex items-center justify-center text-sm text-black px-2 py-1 text-center">
        <p className="promo-text flex flex-wrap justify-center items-center gap-x-1">
          IT’S SEASON OF LOVE, GET <strong>500K</strong> DISCOUNT FOR BOWERS & WILKINS PX7 S3 & PX8 | ENTER CODE:{" "}
          <strong>LOVEBW500</strong>
        </p>
      </div> */}
      <nav className="fixed top-[50px] left-0 w-full bg-white shadow-md transition-transform duration-300 z-[999]">
      {/* <nav className="fixed left-0 w-full bg-white shadow-md transition-transform duration-300 z-[999]" style={{marginTop:"-8rem"}}> */}
        {/* <div className="max-w-[105rem] mx-auto flex items-center justify-between p-4"> */}
        <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16 2xl:px-20 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link
              to="/"
              className="flex-shrink-0 hidden md:flex flex items-center w-64"
            >
              <img src={LogoBrand} alt="Logo" className="h-16" />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-10 text-lg">
              <Link
                onClick={() => {
                  setIsOpen(false);
                  setMegaMenuVisible(false);
                }}
                to="/"
                className="hover:text-gray-500 text-black"
              >
                Home
              </Link>
              <div className="relative">
                <button
                  onClick={() => {
                    handleProductsClick();
                    setMegaMenuVisible(false);
                  }}
                  className="text-black px-4 py-2 rounded-lg hover:bg-gray-200 transition"
                >
                  Products
                </button>

                {isOpen && (
                  <div className="fixed left-0 w-full bg-white border border-gray-300 shadow-lg z-50">
                    <div className="px-10 py-4 grid grid-cols-3 gap-4">
                      {/* Left Column: Categories */}
                      {/* <div className="col-span-1">
              <ul className="flex flex-col gap-2">
                <li
                  className={`text-black px-4 py-2 cursor-pointer transition ${
                    selectedTab === "New Products"
                      ? "bg-black text-white"
                      : "hover:bg-black hover:text-white"
                  }`}
                  onClick={() => {
                    setSelectedTab("New Products");
                    fetchNewProducts();
                  }}
                >
                  New Products
                </li>
                <li
                  className="px-4 py-2 hover:bg-black hover:text-white cursor-pointer font-bold"
                  onClick={() => setIsOpen(false)}
                >
                  <Link
                    to="/all-produk-new"
                    className="block w-full h-full"
                  >
                    View All
                  </Link>
                </li>

                {categories.map((category) => (
                  <li
                    key={category.id}
                    className={`text-black px-4 py-2 cursor-pointer ${
                      selectedKategori === category.id
                        ? "bg-black text-white"
                        : "hover:bg-black hover:text-white"
                    }`}
                    onClick={() => handleCategoryClick(category.id)}
                  >
                    {category.nama_kategori}
                  </li>
                ))}
              </ul>
            </div> */}

                      <div className="col-span-1">
                        <ul className="flex flex-col gap-2">
                          <li
                            className={`text-black px-4 py-2 cursor-pointer transition ${
                              activeTab === "new-products"
                                ? "bg-black text-white"
                                : "hover:bg-black hover:text-white"
                            }`}
                            onClick={() => {
                              setActiveTab("new-products");
                              fetchNewProducts();
                            }}
                          >
                            New Products
                          </li>

                          <li
                            className={`text-black px-4 py-2 cursor-pointer transition ${
                              activeTab === "view-all"
                                ? "bg-black text-white"
                                : "hover:bg-black hover:text-white"
                            }`}
                            onClick={() => {
                              setActiveTab("view-all");
                              setIsOpen(false);
                            }}
                          >
                            <Link
                              to="/all-produk-new"
                              className="block w-full h-full"
                            >
                              View All
                            </Link>
                          </li>

                          {categories.map((category) => (
                            <li
                              key={category.id}
                              className={`text-black px-4 py-2 cursor-pointer transition ${
                                activeTab === category.id
                                  ? "bg-black text-white"
                                  : "hover:bg-black hover:text-white"
                              }`}
                              onClick={() => {
                                setActiveTab(category.id);
                                handleCategoryClick(category.id);
                              }}
                            >
                              {category.nama_kategori}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="col-span-2">
                        {kategoriId && (
                          <div className="flex justify-end">
                            <button
                              className="mb-4 px-4 py-2 bg-black text-white rounded hover:bg-blue-600"
                              onClick={() => {
                                setIsOpen(false);
                                navigate(`/produk-kategori/${kategoriId}`);
                              }}
                            >
                              View All
                            </button>
                          </div>
                        )}

                        {loading ? (
                          <p className="text-center">Loading...</p>
                        ) : error ? (
                          <p className="text-center text-red-500">{error}</p>
                        ) : produk.length > 0 ? (
                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 cursor-pointer">
                            {produk.slice(0, 6).map((item) => (
                              <div
                                // key={item.id}
                                key={item.nama_produk}
                                className="relative p-2"
                              >
                                {isNewProduct(item.createdAt) && (
                                  <span className="absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-1 rounded-md font-semibold">
                                    NEW
                                  </span>
                                )}
                                <img
                                  onClick={() => {
                                    setIsOpen(false);
                                    // navigate(`/produk/all/${item.id}`);
                                    navigate(`/all-produk/${item.nama_produk}`);
                                  }}
                                  src={item.image[0]}
                                  alt={item.nama_produk}
                                  className="w-full h-24 sm:h-28 md:h-32 object-contain rounded-lg"
                                />
                                <p className="text-center mt-2 text-sm sm:text-base md:text-lg text-black font-medium">
                                  {item.brand.nama_brand} {item.nama_produk}
                                </p>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-center text-gray-600">
                            No new products available.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Link
                onClick={() => {
                  setIsOpen(false);
                  setMegaMenuVisible(false);
                }}
                to="/all-brand"
                className="hover:text-gray-500 text-black"
              >
                Brands
              </Link>
              <Link
                onClick={() => {
                  setIsOpen(false);
                  setMegaMenuVisible(false);
                }}
                to="/our-outlet"
                className="hover:text-gray-500 text-black"
              >
                Store
              </Link>
              <Link
                onClick={() => {
                  setIsOpen(false);
                  setMegaMenuVisible(false);
                }}
                to="/e-catalog"
                className="hover:text-gray-500 text-black"
              >
                E-Brochure
              </Link>
            </div>

            {/* Icons & Mobile Menu Button */}
            <Link to="/" className="flex md:hidden items-center  w-32">
              <img src={LogoBrand} alt="Logo" className="h-10" />
            </Link>
            <div className="flex items-center gap-2">
              <IconButton
                onClick={() => {
                  setIsOpen(false);
                  handleSearchIconClick();
                }}
                // onClick={handleSearchIconClick}
                className="focus:outline-none"
              >
                <img src={SearchButton} alt="Search Icon" className="h-7" />
              </IconButton>
              <div className="hidden md:flex">
                <IconButton
                  onClick={() => {
                    setIsOpen(false);
                    handleCartClick();
                    setMegaMenuVisible(false);
                  }}
                  className="relative focus:outline-none w-11 h-11 flex items-center justify-center"
                >
                  {cartCount > 0 && (
                    <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5">
                      {cartCount}
                    </span>
                  )}
                  <img
                    src={CartButton}
                    alt="Cart Icon"
                    className="block w-auto h-8"
                  />
                </IconButton>
              </div>
              <IconButton
                onClick={() => {
                  setIsOpen(false);
                  handleUserMenuClick();
                  setMegaMenuVisible(false);
                }}
                className="hover:rounded-lg hover:rounded-b-0 focus:outline-none relative flex items-center gap-2 hover:bg-gray-100 rounded-md px-3 py-2 transition duration-200"
              >
                <img
                  src={profile?.imageUrl || UserButton}
                  alt="User Image"
                  className="block h-8 w-8 rounded-full object-cover"
                />
                {profile?.nama && (
                  <span className="hidden md:block text-base text-black">
                    Hi, {profile.nama}!
                  </span>
                )}
              </IconButton>

              {isLoggedIn && userMegaMenuVisible && (
                <div className="absolute top-28 right-4 w-64 bg-white shadow-lg z-50 p-2 rounded-lg transition-all duration-300 ease-in-out opacity-100">
                  <div className="flex flex-col items-center p-2">
                    {/* User Avatar */}
                    <img
                      // src={userImage || ""}
                      src={profile.imageUrl}
                      alt="User Avatar"
                      className="h-20 w-20 rounded-full object-cover mx-auto bg-gray-200"
                    />

                    <ul className="space-y-1 text-md text-gray-700 w-full text-center">
                      <li>
                        <button
                          onClick={() => {
                            navigate("/settings");
                            setUserMegaMenuVisible(!userMegaMenuVisible);
                          }}
                          className="block text-black w-full py-1 hover:text-black hover:bg-gray-100 rounded transition"
                        >
                          Account
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => navigate("/order-history")}
                          className="block text-black w-full py-1 hover:text-black hover:bg-gray-100 rounded transition"
                        >
                          Order History
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={handleLogout}
                          className="block w-full py-1 text-red-500 hover:text-red-700 hover:bg-gray-100 rounded transition"
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="hidden md:flex">
                <IconButton
                  onClick={handleLanguageMenuOpen}
                  className="focus:outline-none"
                >
                  {/* <img
      src={FlagIndo}
      alt="Language Selector"
      className="h-7 w-10 object-cover"
    /> */}
                </IconButton>
              </div>
              <div className="relative inline-block">
                {/* Dropdown Menu */}
                {menuOpen && (
                  <div className="absolute top-full right-0 mt-2 bg-white shadow-lg rounded-md z-50">
                    <button
                      onClick={() => handleLanguageMenuClose("en")}
                      className="text-black text-left block px-4 py-2 hover:bg-gray-200 w-full"
                    >
                      English
                    </button>
                    <button
                      onClick={() => handleLanguageMenuClose("id")}
                      className="text-black text-left block px-4 py-2 hover:bg-gray-200 w-full"
                    >
                      Bahasa Indonesia
                    </button>
                  </div>
                )}
              </div>
              <button
                className="md:hidden text-black"
                onClick={() => {
                  setMobileMenuOpen(!mobileMenuOpen);
                  setProductDropdownOpen(false);
                  setMegaMenuVisible(false);
                }}
              >
                {mobileMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-md flex flex-col gap-4 p-4">
            <Link
              to="/"
              className="hover:text-gray-500"
              onClick={() => {
                setMobileMenuOpen(!mobileMenuOpen);
                setProductDropdownOpen(false);
                setIsOpen(false);
              }}
            >
              Home
            </Link>
            <IconButton
              onClick={handleCartClick}
              className="relative focus:outline-none w-10 h-10 flex items-center justify-center"
            >
              {cartCount > 0 && (
                <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5">
                  {cartCount}
                </span>
              )}
              <span className="ml-5 text-left whitespace-nowrap text-base text-black hover:text-gray-500">
                My Cart
              </span>
            </IconButton>
            <button
              onClick={() => setProductDropdownOpen(!productDropdownOpen)}
              className="text-black hover:text-gray-500 text-left"
            >
              Products
            </button>
            {productDropdownOpen && (
              <div className="fixed left-0 w-full bg-white border border-gray-300 shadow-lg z-50">
                <div className="px-10 py-4 gap-4">
                  {/* Left Column: Categories */}
                  <div className="col-span-1">
                    <ul className="flex flex-col gap-2">
                      <li
                        className={`text-black px-4 py-2 cursor-pointer transition ${
                          selectedTab === "New Products"
                            ? "bg-black text-white"
                            : "hover:bg-black hover:text-white"
                        }`}
                        // onClick={() => {
                        //   setSelectedTab("New Products");
                        //   fetchNewProducts();
                        // }}
                        onClick={() => {
                          setMobileMenuOpen(!mobileMenuOpen);
                          setSelectedTab("New Products");
                          fetchNewProducts();
                          setIsOpen(false);
                        }}
                      >
                        <Link to="/all-produk-new">New Products</Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-black hover:text-white cursor-pointer font-bold"
                        // onClick={() => setIsOpen(false)}
                        onClick={() => {
                          setMobileMenuOpen(!mobileMenuOpen);
                          setIsOpen(false);
                        }}
                      >
                        <Link
                          to="/all-produk-new"
                          className="block w-full h-full"
                        >
                          View All
                        </Link>
                      </li>

                      {categories.map((category) => (
                        <li
                          key={category.id}
                          className={`text-black px-4 py-2 cursor-pointer ${
                            selectedKategori === category.id
                              ? "bg-black text-white"
                              : "hover:bg-black hover:text-white"
                          }`}
                          // onClick={() => handleCategoryClickMobile(category.id)}
                          onClick={() => {
                            setMobileMenuOpen(!mobileMenuOpen);
                            handleCategoryClickMobile(category.id);
                            setIsOpen(false);
                          }}
                        >
                          {category.nama_kategori}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
            <Link
              onClick={() => {
                setMobileMenuOpen(!mobileMenuOpen);
                setProductDropdownOpen(false);
                setIsOpen(false);
              }}
              to="/all-brand"
              className="hover:text-gray-500"
            >
              Brands
            </Link>
            <Link
              onClick={() => {
                setMobileMenuOpen(!mobileMenuOpen);
                setProductDropdownOpen(false);
                setIsOpen(false);
              }}
              to="/our-outlet"
              className="hover:text-gray-500"
            >
              Store
            </Link>
            <Link
              onClick={() => {
                setMobileMenuOpen(!mobileMenuOpen);
                setProductDropdownOpen(false);
                setIsOpen(false);
              }}
              to="/e-catalog"
              className="hover:text-gray-500"
            >
              E-Brochure
            </Link>
            {/* <IconButton
              onClick={handleLanguageMenuOpen}
              className="relative focus:outline-none w-10 h-10 flex items-center justify-center"
            >
              <span className="ml-9 text-left whitespace-nowrap text-base text-black hover:text-gray-500">
                Language
              </span>
            </IconButton> */}
          </div>
        )}
        {megaMenuVisible && (
          <div className="absolute top-[88px] left-0 right-0 z-10 p-4 bg-white shadow-lg rounded-md w-full mx-auto">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 text-black text-sm"
            />

            <ul className="mt-4 bg-white rounded-md shadow-md max-h-60 overflow-y-auto w-full">
              {searchResults.length > 0 ? (
                searchResults.map((item) => (
                  <li
                    // key={item.id}
                    key={item.nama_produk}
                    onClick={() => handleSearchItemClick(item)}
                    className="block w-full p-3 border-b border-gray-200 text-black hover:bg-gray-100 cursor-pointer transition-all duration-200"
                  >
                    <div className="font-semibold text-sm">
                      {item.nama_produk}
                    </div>
                    {item.brand?.nama_brand && (
                      <div className="text-xs text-gray-500">
                        by {item.brand.nama_brand}
                      </div>
                    )}
                  </li>
                ))
              ) : (
                <li className="p-3 text-center text-gray-500">
                  No results found
                </li>
              )}
            </ul>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
